import { render, staticRenderFns } from "./LoginComunityInformation.vue?vue&type=template&id=189f8e4c"
import script from "./LoginComunityInformation.vue?vue&type=script&lang=ts"
export * from "./LoginComunityInformation.vue?vue&type=script&lang=ts"
import style0 from "./LoginComunityInformation.vue?vue&type=style&index=0&id=189f8e4c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports